const ACTION_ROW_STATUS_ALIASES = Object.freeze({
  success: Object.freeze(['accepted', 'sent', 'success', 'synced']),
  failed: Object.freeze(['failed', 'error', 'rejected']),
  skipped: Object.freeze(['invalid', 'skipped']),
});

const ACTION_ROW_TRANSIENT_STATUSES = Object.freeze(['queued', 'sending']);

const EMPTY_REASON_BY_CODE = Object.freeze({
  missing_required_fields: 'Missing required fields.',
  validation_failed: 'VMT record validation failed.',
  row_not_found: 'Row was not found in the current source cache.',
});

const ACTION_RESULT_EXPORT_FIELDS = Object.freeze([
  Object.freeze(['index', 'Index']),
  Object.freeze(['status', 'Result']),
  Object.freeze(['bac', 'BAC']),
  Object.freeze(['programName', 'Program']),
  Object.freeze(['productLabel', 'Product']),
  Object.freeze(['referenceId', 'Reference ID']),
  Object.freeze(['orderItemId', 'Order Item ID']),
  Object.freeze(['selectionKey', 'Selection Key']),
  Object.freeze(['diStatus', 'DI Status']),
  Object.freeze(['diSelectionDate', 'DI Selection Date']),
  Object.freeze(['diEffectiveDate', 'DI Effective Date']),
  Object.freeze(['reason', 'Reason']),
]);

const normalizeActionRowStatus = (status, fallback = 'queued') => {
  const value = String(status ?? '').trim().toLowerCase();
  if (ACTION_ROW_STATUS_ALIASES.success.includes(value)) return 'success';
  if (ACTION_ROW_STATUS_ALIASES.failed.includes(value)) return 'failed';
  if (ACTION_ROW_STATUS_ALIASES.skipped.includes(value)) return 'skipped';
  if (ACTION_ROW_TRANSIENT_STATUSES.includes(value)) return value;
  return value || fallback;
};

export {
  ACTION_RESULT_EXPORT_FIELDS,
  ACTION_ROW_STATUS_ALIASES,
  ACTION_ROW_TRANSIENT_STATUSES,
  EMPTY_REASON_BY_CODE,
  normalizeActionRowStatus,
};
